import type { ContentType } from "@pdfking/pdfengine"
import { GenerateFile } from "@pdfking/workflow/actions/pdfengine/Functions"

import type { FileObject } from "../types/FileObject"
import new_file_from_factory from "./new_file_from_factory"

type NewFileFromBytesOptions = {
  blob: Blob
  path: string
}

export default ({ blob, path }: NewFileFromBytesOptions): FileObject =>
  new_file_from_factory({
    path,
    factory: () => GenerateFile([blob], blob.type as ContentType),
  })
